module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-152x152-9be32100144bee80e01f59892f45364f.png";